import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const months = [
    "Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"
  ];
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const day = date.getDate();
  const month = months[date.getMonth()];
  return `${day} ${month}`;
};


const Movieblock = ({
  id,
  title,
  trailer,
  seances,
  original,
  year,
  description,
  poster,
  baners,
  directors,
  genres,
  actors,
  country,
  age,
  display,
  duration,
  rental,
  details_img,
  ua_premiere,
}) => {
  const [displayMode, setDisplayMode] = useState("");

  useEffect(() => {
    if (display === 2) {
      setDisplayMode("3D");
    } else if (display === 1) {
      setDisplayMode("2D");
    }
  }, [display]);

  const rentBlockPremier1Ref = useRef();
  const rentBlockPremier2Ref = useRef();
  const rentBlockPremier3Ref = useRef();
  const rentBlockPremier4Ref = useRef();
  const movieModeRef = useRef();

  useEffect(() => {
    if (rental === 1) {
      rentBlockPremier1Ref.current.style.visibility = "visible";
    } else {
      rentBlockPremier1Ref.current.style.visibility = "hidden";
    }

    if (rental === 2) {
      rentBlockPremier2Ref.current.style.visibility = "visible";
    } else {
      rentBlockPremier2Ref.current.style.visibility = "hidden";
    }

    if (rental === 3) {
      rentBlockPremier3Ref.current.style.visibility = "visible";
    } else {
      rentBlockPremier3Ref.current.style.visibility = "hidden";
    }

    if (rental === 4) {
      rentBlockPremier4Ref.current.style.visibility = "visible";
    } else {
      rentBlockPremier4Ref.current.style.visibility = "hidden";
    }

    if (display === 2) {
      movieModeRef.current.style.visibility = "visible";
    } else {
      movieModeRef.current.style.visibility = "hidden";
    }
  }, [rental, display, seances]);

  return (
    <Link
      to={`/details/${id}`}
      state={{
        id,
        title,
        trailer,
        seances,
        original,
        year,
        description,
        poster,
        baners,
        directors,
        genres,
        actors,
        country,
        age,
        display,
        duration,
        rental,
        details_img,
        ua_premiere,
      }}
    >
      <div className="movie-block">
        <div className="moviedetail-card">
          <img
            className="moviedetail-card-img"
            src={poster}
            alt={title}
            title={title}
          />

          <div ref={movieModeRef} id="movie-mode">
            <svg
              width="34"
              height="35"
              viewBox="0 0 34 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_777_18073)">
                <path
                  d="M9.61563 0.820114C9.06445 0.919724 8.47344 1.11894 7.90234 1.41113C6.38828 2.1748 5.08008 3.83496 4.71484 5.46855C4.54219 6.21894 4.96055 7.03574 5.67773 7.36113C6.03633 7.52715 6.72031 7.52715 7.07227 7.36113C7.45078 7.18847 7.8625 6.71699 8.00195 6.28535C8.39375 5.0834 9.1707 4.37285 10.3062 4.16035C12.1723 3.81504 13.8723 5.52832 13.5535 7.42754C13.3344 8.7623 12.4312 9.60566 11.0699 9.7584C10.1867 9.85137 9.98086 9.91777 9.64883 10.2299C9.25039 10.5951 9.09766 10.9271 9.09766 11.4584C9.09766 11.9564 9.20391 12.2287 9.52266 12.5873C9.82812 12.9193 10.293 13.1252 10.9438 13.1982C11.8137 13.2978 12.2852 13.5303 12.8363 14.1213C13.2215 14.533 13.4672 15.0377 13.5602 15.6154C13.8191 17.1627 12.5906 18.7033 11.0035 18.8229C9.62227 18.9291 8.48672 18.1455 8.0418 16.7775C7.77617 15.9607 7.13867 15.4561 6.375 15.4561C5.3457 15.4561 4.50898 16.4389 4.70156 17.415C4.82773 18.0326 5.18633 18.8561 5.61797 19.4803L6.02969 20.0978L3.74531 21.758C2.48359 22.6744 1.41445 23.4248 1.36797 23.4248C1.02266 23.4248 0.478125 23.8299 0.2125 24.2814L0.0332031 24.5869V29.0361C0.0332031 33.4721 0.0332031 33.4854 0.179297 33.751C0.345313 34.0631 0.670703 34.3818 0.996094 34.5545C1.21523 34.674 1.5207 34.6807 7.83594 34.6807H14.4434L14.709 34.5346C15.2602 34.2357 15.373 34.0498 16.1699 32.0775C16.6281 30.9287 16.9402 30.2314 17 30.2314C17.0598 30.2314 17.3719 30.9287 17.8301 32.0775C18.627 34.0498 18.7398 34.2357 19.291 34.5346L19.5566 34.6807H26.1641C32.4793 34.6807 32.7848 34.674 33.0039 34.5545C33.3293 34.3818 33.6547 34.0631 33.8207 33.751C33.9668 33.4854 33.9668 33.4721 33.9668 29.0361V24.5869L33.7875 24.2814C33.5152 23.8166 33.1699 23.5576 32.6719 23.4314C32.5789 23.4115 31.4367 22.6213 30.1352 21.6783L27.7711 19.9584L28.143 19.4537C28.8336 18.4908 29.2719 17.3752 29.418 16.1865C29.5043 15.4428 29.5043 7.50058 29.418 6.75683C29.1324 4.45918 27.8043 2.52676 25.7789 1.49082C25.0883 1.13223 24.318 0.88652 23.6141 0.786911C22.9367 0.693943 19.1316 0.687302 18.8793 0.786911C18.627 0.879879 18.3281 1.16543 18.2219 1.42441C18.1422 1.60371 18.1289 3.2705 18.1289 11.4916V21.3463L18.2816 21.6385C18.3813 21.8178 18.5406 21.9904 18.7 22.0834C18.959 22.2295 18.9656 22.2295 21.3828 22.2096C23.541 22.1896 23.8598 22.1764 24.2715 22.0568L24.7363 21.9307L25.6594 22.6279L26.5824 23.3252L21.7879 23.3451C19.1582 23.3518 14.8418 23.3518 12.2121 23.3451L7.41758 23.3252L8.20117 22.7275C8.63281 22.3955 9.02461 22.11 9.06445 22.0834C9.11094 22.0568 9.37656 22.0768 9.66211 22.1299C12.6438 22.701 15.6652 20.9279 16.668 18.0061C17.3785 15.9607 16.907 13.61 15.4594 11.9299L15.0676 11.465L15.3996 11.0998C16.7477 9.62558 17.3055 7.37441 16.8008 5.39551C16.6281 4.69824 16.1035 3.65566 15.6387 3.07129C14.2176 1.27832 11.8867 0.408394 9.61563 0.820114ZM12.0527 2.01543C14.968 2.80566 16.5684 5.87363 15.5391 8.6959C15.2602 9.46621 14.9215 9.9709 14.2309 10.6549C13.4074 11.4717 13.4074 11.4982 14.1977 12.2619C14.8949 12.9393 15.227 13.4307 15.5191 14.201C15.7914 14.9314 15.8977 15.6021 15.8445 16.3193C15.6254 19.4537 12.7832 21.6186 9.70859 20.9943C9.39648 20.9346 8.925 20.7619 8.50664 20.5627C7.90234 20.2639 7.74297 20.151 7.21172 19.6197C6.52773 18.9291 6.18242 18.3912 5.94336 17.6342C5.76406 17.0631 5.78398 16.8771 6.05625 16.6912C6.42812 16.4256 6.82656 16.658 7.00586 17.249C7.47734 18.7631 8.90508 19.8521 10.5387 19.9518C11.7074 20.0248 12.6969 19.6396 13.5535 18.783C14.782 17.5545 15.0676 15.8611 14.3238 14.2939C14.0117 13.6498 13.5668 13.1318 12.9891 12.7467C12.4113 12.3615 11.8402 12.1557 11.123 12.076C10.4789 12.0029 10.2664 11.8635 10.2398 11.4982C10.2066 11.0932 10.3859 10.9803 11.1562 10.8939C11.9266 10.8076 12.4379 10.635 12.9957 10.2697C14.6293 9.20058 15.1871 7.02246 14.2973 5.16972C13.9652 4.4791 13.2348 3.74199 12.5309 3.40996C11.2891 2.8123 9.9543 2.85214 8.76562 3.52285C8.01523 3.94121 7.24492 4.92402 6.97266 5.79394C6.85312 6.1791 6.66719 6.3584 6.375 6.3584C6.1293 6.3584 5.91016 6.19238 5.82383 5.94004C5.79727 5.87363 5.85703 5.58808 5.95 5.30918C6.54766 3.51621 8.12813 2.19472 10.0605 1.88261C10.4258 1.82949 11.6477 1.90253 12.0527 2.01543ZM24.2051 2.06855C26.0047 2.61972 27.3395 3.85488 27.9902 5.58808C28.3422 6.51777 28.3621 6.96933 28.3422 11.8369C28.3156 16.1932 28.3156 16.2994 28.1695 16.8174C27.5652 19.0021 25.8719 20.5959 23.7203 21.0076C23.3684 21.074 22.6777 21.1006 21.2434 21.1006H19.2578V11.465V1.82949L21.4359 1.85605C23.5809 1.88261 23.6141 1.88926 24.2051 2.06855ZM28.6742 22.0037C29.6105 22.6877 30.4074 23.2721 30.4406 23.2986C30.4805 23.3318 30.0754 23.3584 29.5043 23.3584H28.5016L27.3527 22.4885C26.7152 22.0104 26.1441 21.5654 26.0844 21.5057C25.9715 21.3994 25.9914 21.3795 26.4164 21.0873C26.6621 20.9213 26.8879 20.7818 26.9145 20.7752C26.9477 20.7752 27.7379 21.3264 28.6742 22.0037ZM7.03242 20.9943C7.09219 21.0475 7.31133 21.1869 7.51719 21.3131L7.88906 21.5389L6.69375 22.4486L5.49844 23.365L4.50898 23.3451L3.51953 23.3252L5.18633 22.11C6.10938 21.4459 6.87305 20.9014 6.89297 20.9014C6.91289 20.9014 6.9793 20.9412 7.03242 20.9943ZM32.7117 24.7064L32.8711 24.8924V29.0428V33.1998L32.6785 33.3924L32.4859 33.585H26.1707H19.8621L19.6961 33.4322C19.5832 33.3326 19.3043 32.7283 18.8262 31.5264C18.441 30.5568 18.0691 29.6736 17.9961 29.5541C17.8301 29.2752 17.3918 29.0561 17 29.0561C16.6082 29.0561 16.1699 29.2752 16.0039 29.5541C15.9309 29.6736 15.559 30.5568 15.1738 31.5264C14.6957 32.7283 14.4168 33.3326 14.3039 33.4322L14.1379 33.585H7.8293H1.51406L1.32148 33.3924L1.12891 33.1998V29.0494C1.12891 24.992 1.12891 24.899 1.26172 24.733C1.33477 24.64 1.46094 24.5471 1.54727 24.5338C1.62695 24.5205 8.63945 24.5072 17.1195 24.5139L32.5523 24.5205L32.7117 24.7064Z"
                  fill="black"
                />
                <path
                  d="M21.084 3.09075C20.7652 3.24348 20.6258 3.38957 20.4863 3.72161C20.4 3.9341 20.3867 4.86379 20.3867 11.4513C20.3867 16.3122 20.4133 19.0282 20.4531 19.1876C20.5395 19.4931 20.9645 19.8849 21.2832 19.9447C21.416 19.9646 21.9738 19.9712 22.5316 19.9579C23.4082 19.9314 23.6141 19.9048 24.0723 19.7454C25.2145 19.3536 26.1973 18.5103 26.6953 17.4876C27.2 16.4517 27.1867 16.6509 27.2133 11.8763C27.2266 9.2134 27.2066 7.39387 27.1668 7.04856C27.034 5.94621 26.6223 5.09622 25.8652 4.33254C25.3141 3.78801 24.743 3.43606 24.0059 3.19036C23.5477 3.04426 23.3285 3.0177 22.4121 2.99114C21.4691 2.97121 21.323 2.97786 21.084 3.09075ZM23.7336 4.2927C24.8027 4.67122 25.4934 5.36848 25.8918 6.4509L26.0645 6.92239V11.438C26.0645 15.9138 26.0645 15.9603 25.9184 16.4185C25.6262 17.3482 25.002 18.072 24.1387 18.4837C23.5543 18.7626 23.1426 18.8423 22.2395 18.8423H21.5156V11.4646V4.0802L22.432 4.12004C23.1293 4.13997 23.4348 4.18645 23.7336 4.2927Z"
                  fill="black"
                />
                <path
                  d="M3.65898 25.6892C3.28047 25.7623 2.83555 26.0279 2.61641 26.3134C2.29102 26.7384 2.25781 27.0041 2.25781 29.0361C2.25781 31.2541 2.29102 31.4466 2.78242 31.9314C3.31367 32.4693 3.17422 32.456 8.20117 32.456C13.2281 32.456 13.0754 32.4693 13.6066 31.9381C13.8855 31.6525 13.9719 31.4732 14.6957 29.6603C15.3531 28.0002 15.4727 27.6416 15.4727 27.3361C15.4727 26.8779 15.2469 26.3865 14.9082 26.0877C14.377 25.6228 14.7289 25.6494 9.06445 25.6361C6.24883 25.6361 3.81836 25.656 3.65898 25.6892ZM14.2043 26.9841C14.284 27.0838 14.3438 27.2299 14.3438 27.3162C14.3438 27.5353 12.9559 31.0017 12.8031 31.1611C12.6836 31.2939 12.5906 31.2939 8.20117 31.2939H3.72539L3.57266 31.1412C3.41992 30.9951 3.41992 30.9619 3.4 29.1822C3.38672 28.1927 3.4 27.3095 3.41992 27.2232C3.43984 27.1435 3.51289 27.0174 3.58594 26.9443C3.71875 26.8115 3.83164 26.8115 8.8918 26.8115H14.0715L14.2043 26.9841Z"
                  fill="black"
                />
                <path
                  d="M19.9086 25.6826C19.125 25.8154 18.534 26.5259 18.5273 27.3361C18.5273 27.6416 18.6469 27.9935 19.3043 29.6603C20.0281 31.4732 20.1145 31.6525 20.3934 31.9381C20.9246 32.4693 20.7719 32.456 25.7988 32.456C30.8258 32.456 30.6863 32.4693 31.2176 31.9314C31.709 31.4466 31.7422 31.2541 31.7422 29.0361C31.7422 26.9642 31.7023 26.7052 31.3438 26.267C31.2309 26.1341 30.9719 25.9416 30.7594 25.8353L30.3809 25.6494L25.3008 25.6361C22.5051 25.6361 20.0812 25.656 19.9086 25.6826ZM30.4141 26.9443C30.4871 27.0174 30.5602 27.1435 30.5801 27.2232C30.6 27.3095 30.6133 28.1927 30.6 29.1822C30.5801 30.9619 30.5801 30.9951 30.4273 31.1412L30.2746 31.2939H25.7988C21.4094 31.2939 21.3164 31.2939 21.1969 31.1611C21.0441 31.0017 19.6562 27.5353 19.6562 27.3162C19.6562 27.2299 19.716 27.0838 19.7957 26.9841L19.9285 26.8115H25.1082C30.1684 26.8115 30.2812 26.8115 30.4141 26.9443Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_777_18073">
                  <rect
                    width="34"
                    height="34"
                    fill="white"
                    transform="translate(0 0.713867)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div className="movie-age">
            <span>{age}+</span>
          </div>

          {/* block rent */}
          <div ref={rentBlockPremier1Ref} id="rent-block-premier_1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="200"
              height="30"
              viewBox="0 0 200 30"
              fill="none"
            >
              <path d="M27 13.5L50 0H100H200V30H0L27 13.5Z" fill="#E10300" />
            </svg>
            <p>Прем’єра</p>
          </div>

          <div ref={rentBlockPremier2Ref} id="rent-block-premier_2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="200"
              height="30"
              viewBox="0 0 200 30"
              fill="none"
            >
              <path d="M27 13.5L50 0H100H200V30H0L27 13.5Z" fill="#FF7A00" />
            </svg>
            <p>Допрем’єрний показ</p>
          </div>

          <div ref={rentBlockPremier3Ref} id="rent-block-premier_3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="200"
              height="30"
              viewBox="0 0 200 30"
              fill="none"
            >
              <path d="M27 13.5L50 0H100H200V30H0L27 13.5Z" fill="black" />
            </svg>
            <p>Повторний прокат</p>
          </div>

          <div ref={rentBlockPremier4Ref} id="rent-block-premier_4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="72"
              height="30"
              viewBox="0 0 72 30"
              fill="none"
            >
              <path d="M0 0H18H36H72V30H0V0Z" fill="#E10300" />
            </svg>
            <p>{formatDate(ua_premiere)}</p>
          </div>
          {/* block rent end*/}
        </div>

        <div className="moviedetail-h-description">
          <h5>{title}</h5>
        
          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Вік: </p>
            <p className="moviedetail-desc-info">{age}+</p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Дата виходу: </p>
            <p className="moviedetail-desc-info">{year}</p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Режим показу: </p>
            <p className="moviedetail-desc-info">{displayMode}</p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Режисер: </p>
            <p className="moviedetail-desc-info">
              {directors &&
                directors.map((director, index) => (
                  <span key={director.name}>
                    {director.name}
                    {index !== directors.length - 1 && " "}
                  </span>
                ))}
            </p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Країна/Студія: </p>
            <p className="moviedetail-desc-info">{country}</p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Жанр: </p>
            <p className="moviedetail-desc-info">
              {genres && genres.join(", ")}
            </p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">У головних ролях: </p>
            <p className="moviedetail-desc-info">
              {actors &&
                actors.map((actor, index) => (
                  <span key={actor.name}>
                    {actor.name}
                    {index !== actors.length - 1 && ", "}
                  </span>
                ))}
            </p>
          </div>

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Мова дубляжу: </p>
            <p className="moviedetail-desc-info">{id===553 ? 'без голосу' : 'українська'}</p>
          </div>

          
          {duration > 0 &&
            <div className="moviedetail-description"><p className="moviedetail-desc-index">Тривалість: </p><p className="moviedetail-desc-info">{duration} хв</p></div>
          }
          

          <div className="moviedetail-description">
            <p className="moviedetail-desc-index">Опис: </p>
            <p className="moviedetail-desc-info">{description}</p>
          </div>
         
        </div>
      </div>
    </Link>
  );
};

Movieblock.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  trailer: PropTypes.string.isRequired,
  seances: PropTypes.object.isRequired,
  original: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  poster: PropTypes.string.isRequired,
  baners: PropTypes.string.isRequired,
  directors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired,
      age: PropTypes.number,
    })
  ).isRequired,
  genres: PropTypes.arrayOf(PropTypes.string).isRequired,
  actors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired,
      age: PropTypes.number,
    })
  ).isRequired,
  country: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  display: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  rental: PropTypes.number.isRequired,
  details_img: PropTypes.arrayOf(PropTypes.string).isRequired,
  ua_premiere: PropTypes.string,
};

export default Movieblock;
